module.exports = __webpack_public_path__ + "static/media/image1.4f8e6197.png";